export default "__VITE_ASSET__df5e0358__"